import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "pagestyle" }
const _hoisted_3 = { class: "dialog-footer" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Setmeal',
  setup(__props) {

  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData:any = reactive({
    companylist:[],
    loading:false,
    title:'',
    addbox:false,
  })
  const form:any = reactive({
    id:"",
    title:"",
    type:1,
    price:0.00,
    count:0,
    point:0,
    giftpoint:0,
    cardnums:0,
    modeltype:0,
    remark:"",
    status:1,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.setmealApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].status = res.data.list[i].status==1?true:false
          res.data.list[i].type = res.data.list[i].type ? parseInt(res.data.list[i].type) : 1
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const save = () => {
    baseData.loading = true
    if(form.id){
      api.setmealApi.edit(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }else{
      api.setmealApi.add(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    if(status){
      status = 1
    }else{
      status = 0
    }
    api.setmealApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    baseData.addbox = true
    baseData.title = '添加套餐'
    form.id = 0
    form.title = ""
    form.type = 1
    form.price = 0.00
    form.count = 0
    form.point = 0
    form.giftpoint = 0
    form.cardnums = 0
    form.modeltype = 0
    form.remark = ""
    form.status = 1
  }
  const edit = (data:any) => {
    baseData.addbox = true
    baseData.title = '编辑套餐'
    form.id = data.id
    form.title = data.title
    form.type = data.type
    form.price = data.price
    form.count = data.count
    form.point = data.point
    form.giftpoint = data.giftpoint
    form.cardnums = data.cardnums
    form.modeltype = data.modeltype
    form.remark = data.remark
    form.status = data.status == true ? 1 : 0
  }
  const del = (id:number) => {
    baseData.loading = true
    api.setmealApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("套餐列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode("创建套餐")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "标题"
            }),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: "充值类型",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.type==1?'金额':'积分'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "price",
              label: "价格（元）",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "count",
              label: "年",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "point",
              label: "积分",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "giftpoint",
              label: "赠送积分",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cardnums",
              label: "名片数量",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "modeltype",
              label: "充值模式",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "remark",
              label: "备注"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "创建时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_switch, {
                  size: "large",
                  onChange: ($event: any) => (changeStatus(scope.row.id,scope.row.status)),
                  modelValue: scope.row.status,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event),
                  "inline-prompt": "",
                  "active-text": "正常",
                  "inactive-text": "暂停"
                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "140"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_popconfirm, {
                  "confirm-button-text": "Yes",
                  "cancel-button-text": "No",
                  title: "你确定要删除?",
                  onConfirm: ($event: any) => (del(scope.row.id))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.addbox,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((baseData.addbox) = $event)),
      title: baseData.title
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (baseData.addbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: save
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.title,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.title) = $event)),
                  autocomplete: "off",
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "充值类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("金额")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("积分")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "价格" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.price,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.price) = $event)),
                  precision: 2,
                  step: 0.1,
                  max: 100000000
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (form.type == 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "年份"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: form.count,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.count) = $event)),
                      precision: 0,
                      step: 1,
                      max: 100000000
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.type == 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "积分"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: form.point,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.point) = $event)),
                      precision: 0,
                      step: 1,
                      max: 100000000
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "赠送积分" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.giftpoint,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.giftpoint) = $event)),
                  precision: 0,
                  step: 1,
                  max: 100000000
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "名片数量" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.cardnums,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.cardnums) = $event)),
                  precision: 0,
                  step: 1,
                  max: 100000000
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "充值模式" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.modeltype,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.modeltype) = $event)),
                  precision: 0,
                  step: 1,
                  max: 100000000
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.remark,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.remark) = $event)),
                  autocomplete: "off",
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("暂停")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})